module.exports = __webpack_public_path__ + "static/media/photonlogo_light_withmargin.3fa82d2c.svg";